import { render } from "./Lunch.vue?vue&type=template&id=e7343348"
import script from "./Lunch.vue?vue&type=script&lang=js"
export * from "./Lunch.vue?vue&type=script&lang=js"

import "./Lunch.vue?vue&type=style&index=0&id=e7343348&lang=css"

import exportComponent from "/home/ic/Project/webb/lunch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__